import type { SharedExtensionMetaInfoArg, SharedExtensionParam } from './model-types'

// Shared pieces of the v1 method model — the shapes several kinds emit identically.

// Every helper-route method (dictionaries, the generated loaders, and the OAuth/trigger SYSTEM methods) is
// invoked with a single wrapper param — `payload` or `invocation` — via the console's helper-method route.
// The method itself carries no per-field model params, so its input scheme is just that wrapper.
export function opaqueParam(name: string, type = 'OBJECT'): SharedExtensionParam {
  return { name, required: false, description: '', type }
}

// Describe a method's params in `metaInfo.args` (mirroring how actions describe theirs) so the method
// advertises a labelled input instead of an empty `args` — consumers (AI tools, the console UI) rely on it.
export function argsFromParams(params: SharedExtensionParam[]): Record<string, SharedExtensionMetaInfoArg> {
  const args: Record<string, SharedExtensionMetaInfoArg> = {}

  for (const param of params) {
    const arg: SharedExtensionMetaInfoArg = { label: param.label ?? param.name }

    if (param.uiComponent) {
      arg.uiComponent = param.uiComponent
    }

    if (param.dictionary) {
      arg.dictionary = param.dictionary
    }

    if (param.dependsOn) {
      arg.dependsOn = param.dependsOn
    }

    args[param.name] = arg
  }

  return args
}
